export default __webpack_public_path__ + "src/assets/ensembl-tagline-r.svg";